/**
 * When Mixpanel Session Replay quota is exhausted (or /record returns 4xx/5xx), the SDK
 * keeps retrying and Datadog RUM surfaces those as resource/network noise.
 * We detect failed /mxpnl/record responses, stop recording for the tab, and set a flag
 * so funnel-driven code does not call start_session_recording again this session.
 */
const STORAGE_KEY = "mxp_session_replay_unavailable"

const isRecordUrl = (url) => typeof url === "string" && url.includes("/mxpnl/record")

const markReplayUnavailable = () => {
  try {
    sessionStorage.setItem(STORAGE_KEY, "1")
  } catch {
    /* private mode / blocked storage */
  }
  window.App = window.App || {}
  window.App.mixpanelSessionReplayBlocked = true
  try {
    if (typeof window.mixpanel?.stop_session_recording === "function") {
      window.mixpanel.stop_session_recording()
    }
  } catch {
    /* ignore */
  }
}

const syncBlockedFromStorage = () => {
  window.App = window.App || {}
  try {
    if (sessionStorage.getItem(STORAGE_KEY) === "1") {
      window.App.mixpanelSessionReplayBlocked = true
    }
  } catch {
    /* ignore */
  }
}

export function installMixpanelReplayQuotaGuard() {
  if (typeof window === "undefined" || window.__mxpReplayQuotaGuardInstalled) return
  window.__mxpReplayQuotaGuardInstalled = true

  syncBlockedFromStorage()

  const recordUrlFailed = (url, status) =>
    isRecordUrl(url) && typeof status === "number" && status >= 400

  const origFetch = window.fetch.bind(window)
  window.fetch = function (input, init) {
    const url = typeof input === "string" ? input : input?.url
    return origFetch(input, init).then((response) => {
      if (recordUrlFailed(url, response.status)) {
        markReplayUnavailable()
      }
      return response
    })
  }

  const { open: xhrOpen, send: xhrSend } = XMLHttpRequest.prototype
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__mxpRequestUrl = url
    return xhrOpen.call(this, method, url, ...rest)
  }
  XMLHttpRequest.prototype.send = function (body) {
    this.addEventListener(
      "load",
      function () {
        const url = this.__mxpRequestUrl
        if (recordUrlFailed(typeof url === "string" ? url : String(url || ""), this.status)) {
          markReplayUnavailable()
        }
      },
      { once: true }
    )
    return xhrSend.call(this, body)
  }
}
